export default "__VITE_ASSET__6d6853c0__"